const LOCAL_KEYS = ['persist:userguiding', 'bp.tour.passport-redesign']
const SESSION_KEYS = ['___ug___']

const cleanupLegacyGuides = () => {
  LOCAL_KEYS.forEach(key => {
    try { window.localStorage.removeItem(key) } catch (e) { return undefined }
    return undefined
  })
  SESSION_KEYS.forEach(key => {
    try { window.sessionStorage.removeItem(key) } catch (e) { return undefined }
    return undefined
  })
}

export default cleanupLegacyGuides
